module.exports = __webpack_public_path__ + "static/media/2 shark realism black and grey  great white realisric sharks.1280x1707.9d485ee7.webp";